import { render } from "./Themusicbar.vue?vue&type=template&id=f5a50fc6&scoped=true"
import script from "./Themusicbar.vue?vue&type=script&lang=js"
export * from "./Themusicbar.vue?vue&type=script&lang=js"

import "./Themusicbar.vue?vue&type=style&index=0&id=f5a50fc6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5a50fc6"]])

export default __exports__